<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    scrollable
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="store != null && store.info != null"
                >{{ store.info.companyName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ $t("store_location") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align: right"></v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
        <GmapMap
          v-if="store != null && store.coords != null"
          :center="store.coords"
          :zoom="18"
          map-type-id="terrain"
          class="gmap"
        >
          <GmapMarker :position="store.coords" :clickable="true" :draggable="true" />
        </GmapMap>

        <v-card-actions>
          <v-row class="store-info">
            <v-col cols="6">
              <div v-if="address != null" class="address">
                <div class="address-title">{{ $t("address") }}</div>
                <div v-if="address.street != null">
                  <span v-if="address.unit != null && address.unit != null && address.unit != ''">Unit {{ address.unit }}, </span
                  >{{ address.street }}
                </div>
                <div v-if="address.city != null">{{ address.city }}</div>
                <div v-if="address.province != null">
                  {{ address.province }}
                </div>
                <div v-if="address.tel != null">{{ address.tel }}</div>
              </div>
            </v-col>
            <v-col cols="6">
              <div v-if="businessHours != null" class="business-hours">
                <div class="business-hours-title">
                  {{ $t("business_hours") }}
                </div>

                <v-row v-for="(bh, index) in businessHours" :key="index">
                  <v-col cols="4">{{ bh.day | downame }}</v-col>
                  <v-col cols="8">{{ bh | timerange }}</v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    store: null,
  }),

  created() {},

  computed: {
    address() {
      if (this.store == null || this.store.info == null) {
        return undefined;
      } else {
        return this.store.info.address;
      }
    },

    businessHours() {
      if (this.store == null || this.store.info == null) {
        return undefined;
      } else {
        return this.store.info.businessHours;
      }
    },
  },

  methods: {
    open(store) {
      this.store = store;    
      if (this.store == null)
        this.store = this.$store.state.store;  
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card__text {
  padding: 0px !important;
}

.v-card__actions {
  padding: 10px 20px !important;
}

.gmap {
  width: 100%;
  height: calc(100vh - 400px);
}

@media screen and (min-width: 960px) {
  .gmap {
    width: 100%;
    height: calc(100vh - 500px);
  }
}

.store-info {
  .col {
    padding: 0px !important;
  }
}

.address {
  font-size: 1em;
}

.address-title {
  color: var(--v-accent-base);
  font-weight: bold;
}

.business-hours {
  font-size: 1em;

  .row {
    margin: 0px;
  }
  .col {
    padding: 0px;
    font-size: 0.9em;
  }
}

.business-hours-title {
  color: var(--v-accent-base);
  font-weight: bold;
}
</style>
